import { render } from "./WizardIndicator.vue?vue&type=template&id=54ef0db5&scoped=true"
import script from "./WizardIndicator.vue?vue&type=script&lang=js"
export * from "./WizardIndicator.vue?vue&type=script&lang=js"

import "./WizardIndicator.vue?vue&type=style&index=0&id=54ef0db5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ef0db5"]])

export default __exports__